import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import {
  ContentManagementService,
  IGetCourseStudyUnitSubjectToSelect,
} from '../../../Services/content-management/content-management.service';
import { StudyUnitTopic } from 'src/app/Models/StudyUnitTopic';
import { QuestionStatusModel } from 'src/app/Models/QuestionStatusById';
import { FormBuilder, FormGroup } from '@angular/forms';
import { VStudyUnit } from 'src/app/Validators/Validators';
import { ToastrService } from 'ngx-toastr';
import { ChangeDetectorRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { forkJoin, of } from 'rxjs';
import { ConstantVars } from 'src/app/utils/constants/constants';
import { catchError } from 'rxjs/operators';
import { IGetCodes } from 'src/app/interfaces/codes';
import { ModalService } from 'src/app/Services/confirmation-modal/modalServie.service';
export interface ISelectedNodes {
  Study_Unit_ID: number;
  Subject_ID: number;
  Subject_Name: string;
  Selected_For_Current_Study_Unit_IND: string;
  Available_To_Include_IND: string;
  Display_Order: number;
  Testing_Probability_Type_Name: string | null;
  Testing_Probability_Type_Code: string | null;
}

export interface ITreeNode {
  ID: number;
  Parent_Id: number;
  Display_Order: number;
  Name: string;
  Subject_Level_Type_Code: string;
  Status_Code: string;
  ChildNodeExistInd: string;
  Study_Unit_Ind: string;
  Subject_Short_Code: string;
  Data: ITreeNode[] | null;
  LoggedInUserID: null;
  sessionLanguageTypeCode: null;
  Exam_Instance_Concept_Exists_Ind: string;
  Total_Count: number;
  WIP_Count: number;
  Submitted_Count: number;
  Under_Review_Count: number;
  Rework_Count: number;
  Approved_Count: number;
  defer_Count: number;
  Rejected_Count: number;
  checked?: boolean;
  previous?: boolean;
  TestingProbabilityTypeCode?: string | null;
}

@Component({
  selector: 'app-content-studyunit-topics',
  templateUrl: './content-studyunit-topics.component.html',
  styleUrls: ['./content-studyunit-topics.component.css'],
})
export class ContentStudyunitTopicsComponent implements OnInit {
  @Input() subjectById: any;
  @Input() StudyUnitID: any;
  @Input() StudyUnitPopupflag: any;
  @Input() EditStudyUnitTopicflag: any;
  @Input() Refresh: any;
  @Output() closeall: EventEmitter<any> = new EventEmitter<any>();
  @Output() getsubjectDataRefresh: EventEmitter<any> = new EventEmitter<any>();
  @Output() CloseSUTopics: EventEmitter<any> = new EventEmitter<any>();
  tempvariable: boolean = false;
  private initialSelectionSnapshot = '';
  hasUnsavedChanges = false;
  MajorTopics: ITreeNode[] | null = null;
  selectedNodes: {
    ID: number;
    Display_Order: number;
    TestingProbabilityTypeCode?: string | null;
  }[] = []; // ✅ Updated to store ID & Display_Order

  InsertStudyUnitTopic: StudyUnitTopic;
  formStudyUnitTopics: FormGroup;
  AvailableStudyUnits: IGetCourseStudyUnitSubjectToSelect[];
  TestingProbabilityType: IGetCodes[];
  constructor(
    private cdr: ChangeDetectorRef,
    public service: ContentManagementService,
    private fb: FormBuilder,
    private toastr: ToastrService,
    private route: ActivatedRoute,
    private modalService: ModalService,
  ) {}
  InitializeForm() {
    this.formStudyUnitTopics = this.fb.group({
      Study_Unit_Id: [''],
      UDTSubjectOrder: [''],
    });
  }
  ngOnInit() {
    this.InitializeForm();
    this.getBreadcrumbDetails();
    this.loadStudyUnitAndCourseSubjects();
    this.getTestingProbabilityType();
  }
  onTestingProbabilityChange(item: any, selectedCode: string) {
    if (item.TestingProbabilityTypeCode === selectedCode) {
      const index = this.selectedNodes.findIndex((e) => e.ID === item.ID);
      if (index !== -1) {
        this.selectedNodes[index].TestingProbabilityTypeCode = selectedCode;
      }
    } else {
      // ✅ Select new option
      item.TestingProbabilityTypeCode = selectedCode;
      console.log(this.selectedNodes, 'kokopokopk......');

      const index = this.selectedNodes.findIndex((e) => e.ID === item.ID);
      if (index !== -1) {
        this.selectedNodes[index].TestingProbabilityTypeCode = selectedCode; // ✅ Set new selection
      } else {
        // ✅ If the item is not in selectedNodes, add it
        this.selectedNodes.push({
          ID: item.ID,
          Display_Order: item.Display_Order,
          TestingProbabilityTypeCode: selectedCode,
        });
      }
    }
    this.recomputeDirtyFlag();

  }


  // === Call this AFTER initial data is ready ===
private takeInitialSnapshot(): void {
  this.initialSelectionSnapshot = this.buildSelectionSnapshot(this.selectedNodes);
  this.hasUnsavedChanges = false;
}

// Build a stable, comparable string from the current selection
private buildSelectionSnapshot(sel: {
  ID: number;
  Display_Order: number;
  TestingProbabilityTypeCode?: string | null;
}[]): string {
  const normalized = (sel || [])
    .map(s => ({
      ID: s.ID,
      // include probability code; null vs '' should be treated same:
      TestingProbabilityTypeCode: (s.TestingProbabilityTypeCode ?? null)
    }))
    // sort by ID to avoid order differences
    .sort((a, b) => a.ID - b.ID);

  return JSON.stringify(normalized);
}

// Recompute dirty flag whenever selection changes
private recomputeDirtyFlag(): void {
  const current = this.buildSelectionSnapshot(this.selectedNodes);
  this.hasUnsavedChanges = current !== this.initialSelectionSnapshot;
}

  getTestingProbabilityType() {
    this.service
      .getDropdownListByCode('TESTING_PROBABILITY_TYPE')
      .subscribe((res) => {
        this.TestingProbabilityType = res.sort(
          (a: IGetCodes, b: IGetCodes) => a.Display_Order - b.Display_Order
        );
      });
  }
  loadStudyUnitAndCourseSubjects() {
    const params = this.route.snapshot.queryParams;
    if (params['c_id']) {
      const studyUnitId = this.StudyUnitID?.Study_Unit_Id;
      forkJoin({
        courseSubjects: this.service
          .GetCourseStudyUnitSubjectToSelect$(null, params['c_id'], studyUnitId)
          .pipe(
            catchError((error) => {
              console.error('Error fetching course subjects:', error);
              return of([]); // Return an empty array or a fallback value
            })
          ),
        studyUnitSubjects: this.service
          .GetStudyUnitSubject({
            Study_Unit_Id: studyUnitId,
          })
          .pipe(
            catchError((error) => {
              console.error('Error fetching study unit subjects:', error);
              return of({ MasterList: [] }); // Return a fallback object
            })
          ),
      }).subscribe(
        ({ courseSubjects, studyUnitSubjects }) => {
          // ✅ Store Available Study Units
          this.AvailableStudyUnits = [...courseSubjects];

          // ✅ Store Study Unit Subjects
          this.subject = (studyUnitSubjects as any)?.MasterList;
          this.getSubjectlist = this.subject;

          // ✅ Filter Selected Nodes
          this.selectedNodes = this.subject
            .filter((ele) => ele.Selected_For_Current_Study_Unit_IND === 'Y')
            .map((e) => ({
              ID: e.Subject_ID,
              Display_Order: e.Display_Order,
              TestingProbabilityTypeCode: e.Testing_Probability_Type_Code,
            }));
          // ✅ Load Initial Data
          this.loadInitialData(this.subjectById.Subject_Id);
        },
        (error) => {
          console.error('Error fetching data:', error);
        }
      );
    }
  }

  ngAfterContentChecked(): void {
    this.cdr.detectChanges();
  }

  loadInitialData(id: number) {
    const payload = {
      ScreenName: 'SUBJECT BREAKDOWN',
      CurrentNodeID: id,
      ChildRecordStatus: 'ALL',
      CalledFrom: null,
    };

    this.service.getSubjectTree(payload).subscribe(
      (res: ITreeNode[]) => {
        this.MajorTopics = res;
        this.marked =this.markSelectedNodes(this.MajorTopics);

        // ✅ Expand all nodes AFTER data is loaded
        this.expandAllNodes();
    setTimeout(() => this.takeInitialSnapshot(), 0);

      },
      (error) => console.error(error)
    );
  }

  enableDisableCheckBox(node: ITreeNode): boolean {

    const found = this.AvailableStudyUnits.find(
      (e) => e.Subject_ID === node.ID
    );
    if (found  || node.previous) {
      return false;
    } else {
      return true;
    }
  }

  getSubjectTree(node: ITreeNode) {
    if (!node || node.ChildNodeExistInd !== 'Y' || node.Data || (node as any).loading) return; // Prevent unnecessary API calls

    (node as any).loading = true;

    const payload = {
      ScreenName: 'SUBJECT BREAKDOWN',
      CurrentNodeID: node.ID,
      ChildRecordStatus: 'ALL',
      CalledFrom: null,
    };

    this.service.getSubjectTree(payload).subscribe(
      (res: ITreeNode[]) => {
        (node as any).loading = false;
        node.Data = res; // Populate child nodes
        this.markSelectedNodes(node.Data); // ✅ Mark selected checkboxes
        this.recursivelyExpandNodes(node.Data); // ✅ Expand fetched children
      },
      (error) => {
        (node as any).loading = false;
        console.error(error);
      }
    );
  }
  marked: boolean = false;
  markSelectedNodes(nodes: ITreeNode[] | null): boolean {
    if (!nodes || nodes.length === 0) {
      // empty branch counts as "fully checked"
      return true;
    }

    // we'll assume everything is checked until we find a reason it's not
    let allChecked = true;

    nodes.forEach((node) => {
      const isSelected = this.selectedNodes.some(
        (selected) => selected.ID === node.ID
      );

      node.checked = isSelected;
      node.previous = isSelected;

      node.TestingProbabilityTypeCode =
        this.selectedNodes.find((selected) => selected.ID === node.ID)
          ?.TestingProbabilityTypeCode ?? null;

      // recurse into children
      if (node.Data) {
        const childAllChecked = this.markSelectedNodes(node.Data);

        // if any child subtree is not fully checked,
        // then this subtree is not fully checked
        if (!childAllChecked) {
          allChecked = false;
        }
      }

      // also, if THIS node itself is not checked,
      // then the subtree can't be fully checked
      if (!node.checked) {
        allChecked = false;
      }
    });

    return allChecked;
  }


  expandAllNodes() {
    this.recursivelyExpandNodes(this.MajorTopics);
  }

  recursivelyExpandNodes(nodes: ITreeNode[] | null) {
    if (!nodes) return;

    nodes.forEach((node) => {
      if (node.ChildNodeExistInd === 'Y' && !node.Data && !(node as any).loading) {
        this.getSubjectTree(node);
      }
      if (node.Data && node.Data.length > 0) {
        this.recursivelyExpandNodes(node.Data);
      }
    });
  }

onCheckboxChange(node: ITreeNode) {
  // If turned ON and no value yet -> assign default
  if (node.checked && (node.TestingProbabilityTypeCode == null || node.TestingProbabilityTypeCode === '')) {
    const defCode = this.getDefaultTestingProbCode();
    if (defCode) {
      node.TestingProbabilityTypeCode = defCode;

      // add/update in selectedNodes immediately
      const idx = this.selectedNodes.findIndex(s => s.ID === node.ID);
      if (idx !== -1) {
        this.selectedNodes[idx].TestingProbabilityTypeCode = defCode;
      } else {
        this.selectedNodes.push({
          ID: node.ID,
          Display_Order: node.Display_Order,
          TestingProbabilityTypeCode: defCode,
        });
      }
    }
  }

  // Recompute selected nodes (keeps parent state consistent)
  this.selectedNodes = this.getCheckedNodes(this.MajorTopics);
  this.recomputeDirtyFlag();
}


  // In ContentStudyunitTopicsComponent (top-level)
private getDefaultTestingProbCode(): string | null {
  if (!this.TestingProbabilityType || !this.TestingProbabilityType.length) return null;

  // 1) Try to find "Average" by description
  const avg = this.TestingProbabilityType.find(
    t => (t.Description || '').trim().toLowerCase() === 'average'
  );
  if (avg) return avg.Code;

  // 2) Otherwise, choose the middle item by Display_Order
  const sorted = [...this.TestingProbabilityType].sort(
    (a, b) => a.Display_Order - b.Display_Order
  );
  const mid = sorted[Math.floor((sorted.length - 1) / 2)];
  return mid?.Code ?? null;
}


  getCheckedNodes(nodes: ITreeNode[] | null): {
    ID: number;
    Display_Order: number;
    TestingProbabilityTypeCode?: string | null;
  }[] {
    if (!nodes) return [];

    let selected: {
      ID: number;
      Display_Order: number;
      TestingProbabilityTypeCode?: string | null;
    }[] = [];

    nodes.forEach((node) => {
      if (node.checked) {
        selected.push({
          ID: node.ID,
          Display_Order: node.Display_Order,
          TestingProbabilityTypeCode: node.TestingProbabilityTypeCode || null,
        });
      }
      if (node.Data) {
        selected = selected.concat(this.getCheckedNodes(node.Data));
      }
    });

    return selected;
  }

  onSelectedNodesChange(
    arg : {selectedNodes: {
      ID: number;
      Display_Order: number;
      TestingProbabilityTypeCode?: string | null;
    }[]
    checked:boolean
  }
    ,
  ) {
    if(this.marked || arg.checked ){
    this.selectedNodes = this.getCheckedNodes(this.MajorTopics);
    this.recomputeDirtyFlag();
    }
  }



  Breadcrumblist: any;
  Breadcrumb: string;
  ID: number;
  getBreadcrumbDetails() {
    // this.service.getBreadcrumbDetails({ 'ID': this.subjectById.Subject_Id }).subscribe((i: any) => {
    //   this.Breadcrumblist = i;
    if (this.EditStudyUnitTopicflag) {
      this.ID = this.StudyUnitID.Study_Unit_Id;
    }
    if (!this.EditStudyUnitTopicflag) {
      this.ID = this.subjectById.Subject_Id;
    }
    this.service
      .getBreadcrumb({ ID: this.ID, Screenname: 'CONTENT_MANAGEMENT' })
      .subscribe(
        (i: any) => {
          this.Breadcrumblist = i;
          this.Breadcrumb = this.Breadcrumblist.Data;
        },
        (error) => {
          console.log(error);
        }
      );
  }
  getSubjectlist: any;
  subject: ISelectedNodes[];

  Checkevent(data: any) {
    this.eventCheck(data.target);
  }
  count: number = 0;
  count1: number = 0;
  eventCheck(data: any) {
    if (this.getSubjectlist != null) {
      this.count = 0;
      this.count1 = 0;
      for (let item of this.getSubjectlist) {
        if (item.Subject_Name == data.value) {
          if (item.checkedflag) {
            item.checkedflag = false;
            if (this.EditStudyUnitTopicflag) {
              if (item.Selected_For_Current_Study_Unit_IND == 'N') {
                //if(item.Available_To_Include_IND=='Y')
                this.tempvariable = false;
              }
            }
          } else {
            item.checkedflag = true;
            if (this.EditStudyUnitTopicflag) {
              if (item.Selected_For_Current_Study_Unit_IND == 'N') {
                //if(item.Available_To_Include_IND=='Y')
                this.tempvariable = true;
              }
            }
          }
        }
      }
      if (this.EditStudyUnitTopicflag) {
        for (let item of this.getSubjectlist) {
          if (item.Selected_For_Current_Study_Unit_IND == 'Y') {
            //if(item.Available_To_Include_IND=='N')
            this.count++;
          }
        }
        for (let item of this.getSubjectlist) {
          if (item.Selected_For_Current_Study_Unit_IND == 'Y') {
            //if(item.Available_To_Include_IND=='N')
            if (item.checkedflag) {
              this.count1++;
            }
          }
        }

        if (this.count1 == this.count) {
          this.tempvariable = false;
        }

        for (let item of this.getSubjectlist) {
          if (this.count > 1) {
            if (item.Selected_For_Current_Study_Unit_IND == 'Y') {
              //if(item.Available_To_Include_IND=='N')
              if (!item.checkedflag) {
                this.tempvariable = true;
              }
            }
          }
        }

        for (let item of this.getSubjectlist) {
          if (item.Selected_For_Current_Study_Unit_IND == 'N') {
            //if(item.Available_To_Include_IND=='Y')
            if (item.checkedflag) {
              this.tempvariable = true;
            }
          }
        }
      }

      this.checkboxvalidation();
    }
  }

  error1: any = { isError: false, errorMessage: '' };
  check: boolean = false;
  checkboxvalidation() {
    if (this.getSubjectlist != null) {
      this.check = false;
      for (let item of this.getSubjectlist) {
        if (item.checkedflag) {
          this.check = true;
          break;
        }
      }
      if (this.check) {
        this.error1 = { isError: false, errorMessage: '' };
      } else {
        this.error1 = {
          isError: true,
          errorMessage: 'Select at least one subject',
        };
        this.tempvariable = false;
      }
    }
  }

  save_submitted: boolean = false;
  Response: any;
  Modalclose: boolean;
  topic: any;
  AddStudyUnitTopics() {
    this.checkboxvalidation();
    if (!this.error1.isError) {
      this.InsertStudyUnitTopic = this.formStudyUnitTopics.value;
      this.InsertStudyUnitTopic.Study_Unit_Id = this.StudyUnitID.Study_Unit_Id;
      if (this.getSubjectlist != null) {
        let UDTReason: any[] = [];
        this.topic = this.getSubjectlist.filter(
          (item: { checkedflag: boolean }) => item.checkedflag == true
        );
        this.topic.forEach(
          (element: { Subject_ID: any; Display_Order: any }) => {
            let list: any = {};
            list['SubjectId'] = element.Subject_ID;
            list['Display_Order'] = element.Display_Order;
            UDTReason.push(list);
          }
        );
        this.InsertStudyUnitTopic.UDTSubjectOrder = UDTReason;
      }

      this.service
        .CreateOrModifyStudyUnitSubject(this.InsertStudyUnitTopic)
        .subscribe(
          (i: any) => {
            this.Response = i;
            if (this.Response.Message == 'Success') {
              this.toastr.success('StudyUnit Topic Added Successfully', '', {
                timeOut: ConstantVars.ToastErrorTimeout,
              });
              this.takeInitialSnapshot();
              this.save_submitted = false;
              this.closeall.emit(this.Modalclose);
              this.getsubjectDataRefresh.emit(this.Refresh);
            } else {
              this.toastr.error(this.Response.Message, '', {
                timeOut: ConstantVars.ToastErrorTimeout,
              });
            }
          },
          (error) => {
            console.log(error);
          }
        );
    }
  }
  // #region OnSave
  SaveStudyUnitTopics() {
    if (this.selectedNodes.length > 0) {
      if (
        this.selectedNodes.some((e) => e.TestingProbabilityTypeCode === null)
      ) {
        this.toastr.error(
          'Please select  Testing probability for selected subjects or unselect it ',
          '',
          {
            timeOut: ConstantVars.ToastErrorTimeout,
          }
        );
        return;
      }
      const payload = {
        Study_Unit_Id: this.StudyUnitID.Study_Unit_Id,
        UDTStudyUnitSubject: this.selectedNodes.map((e) => {
          return {
            Display_Order: e.Display_Order,
            SubjectId: e.ID,
            TestingProbabilityTypeCode: e.TestingProbabilityTypeCode,
          };
        }),
      };
      this.service.CreateOrModifyStudyUnitSubject(payload).subscribe((res) => {
        this.Response = res;
        if (this.Response.Message == 'Success') {
            this.toastr.success('Saved Successfully', 'Success', {
              timeOut: ConstantVars.ToastSucessTimeout,
            });
            this.takeInitialSnapshot();
          this.save_submitted = false;
          this.closeall.emit(this.Modalclose);
          this.getsubjectDataRefresh.emit(this.Refresh);
        } else {
          this.toastr.error(this.Response.Message, '', {
            timeOut: ConstantVars.ToastErrorTimeout,
          });
        }
      });
    } else {
      this.toastr.error('Please select at least one of the topic', '', {
        timeOut: ConstantVars.ToastErrorTimeout,
      });
    }
  }
async Cancel() {
  if (this.hasUnsavedChanges) {
            const result = await this.modalService.open(
          'Confirmation',
          `You have unsaved changes. Do you want to save them before closing?`
        );

    if (result) {
      // Save, then close on success (your Save already emits/close)
      this.SaveStudyUnitTopics();
      return;
    } else {
      // discard and close
      this.CloseSUTopics.emit(this.Modalclose);
      return;
    }
  }

  // no changes, just close
  this.CloseSUTopics.emit(this.Modalclose);
}


  Editformvalidation(data: any) {
    if (this.EditStudyUnitTopicflag) {
      for (let item of this.getSubjectlist) {
        if (item.Subject_Name == data.value) {
          if (item.Selected_For_Current_Study_Unit_IND == 'N') {
            this.tempvariable = true;
            break;
          }
        }
      }
    }
  }
}

@Component({
  selector: 'app-content-studyunit-topics-node',
  styleUrls: ['./content-studyunit-topics.component.css'],
  template: `
    <div class="row tree-row" *ngFor="let node of treeNodes">
      <div class="col-12 d-flex align-items-baseline">
        <div class="px-1 tree-btn-1">
          <button
            type="button"
            class="tree-btn"
            *ngIf="node.ChildNodeExistInd === 'Y'"
            (click)="getSubjectTree(node, true)"
          >
            <i class="fa fa-angle-right" *ngIf="!node.Data"></i>
            <i class="fa fa-angle-down" *ngIf="node.Data"></i>
          </button>
        </div>

        <app-tree-content
          [Text]="node.Name"
          [status]="node.Status_Code"
          ID="node.ID"
        ></app-tree-content>

        <!-- ✅ Bind checkbox to node.checked -->
        <div class="d-flex align-items-center">
          <input
            type="checkbox"
            class="form-check-input-sm"
            [(ngModel)]="node.checked"
            [disabled]="enableDisableCheckBox(node)"
            (change)="onCheckboxChange(node)"
            *ngIf="node.ChildNodeExistInd === 'N'"
          />
          <!-- ✅ Testing Probability Type List -->
          <!-- <span>{{ node.checked| json }} node</span> -->
          <div class="testing-probability-type" *ngIf="node.checked">
            <ng-container *ngFor="let type of TestingProbabilityType">
              <label class=" ms-2 me-2">
                <input
                  type="radio"
                  name="testingProbability_{{ node.ID }}"
                  [value]="type.Code"
                  [(ngModel)]="node.TestingProbabilityTypeCode"
                  (change)="onTestingProbabilityChange(node, type.Code)"
                />
                {{ type.Description }}
              </label>
            </ng-container>
          </div>
        </div>
      </div>

      <div *ngIf="node.Data" class="ms-4">
        <app-content-studyunit-topics-node
          [treeNodes]="node.Data"
          [AvailableStudyUnits]="AvailableStudyUnits"
          [TestingProbabilityType]="TestingProbabilityType"
          [selectedNodes]="selectedNodes"
          (selectedNodesChange)="onSelectedNodesChange($event)"
        ></app-content-studyunit-topics-node>
      </div>
    </div>
  `,
})
export class ContentStudyunitTopicsNodeComponent {
  @Input() AvailableStudyUnits: IGetCourseStudyUnitSubjectToSelect[] = [];
  @Input() treeNodes: ITreeNode[] | null = null;
  @Input() TestingProbabilityType: IGetCodes[] = [];
  @Input() selectedNodes: {
    ID: number;
    Display_Order: number;
    TestingProbabilityTypeCode?: string | null;
  }[] = []; // ✅ Receive saved selections
  @Output() selectedNodesChange = new EventEmitter<
    {selectedNodes:{ ID: number; Display_Order: number }[],checked:boolean}
  >(); // ✅ Emit checked nodes

  constructor(
    private service: ContentManagementService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit() {
    this.markSelectedNodes(this.treeNodes);
    this.onCheckboxChange();
    console.log(this.selectedNodes,"selectedndes",this.treeNodes);

  }
  ngAfterContentChecked(): void {
    this.cdr.detectChanges();
  }
  getSubjectTree(node: ITreeNode, isUserToggle = false) {
    if (!node || node.ChildNodeExistInd !== 'Y') return;

    if (isUserToggle && node.Data && node.Data.length > 0) {
      node.Data = null; // Toggle collapse only on explicit user click
      return;
    }

    if (node.Data || (node as any).loading) return;

    (node as any).loading = true;

    const payload = {
      ScreenName: 'SUBJECT BREAKDOWN',
      CurrentNodeID: node.ID,
      ChildRecordStatus: 'ALL',
      CalledFrom: null,
    };

    this.service.getSubjectTree(payload).subscribe(
      (res: ITreeNode[]) => {
        (node as any).loading = false;
        node.Data = res || []; // Populate child nodes
        this.recursivelyExpandNodes(node.Data);
        this.markSelectedNodes(node.Data); // ✅ Mark saved selections as checked
      },
      (error) => {
        (node as any).loading = false;
        console.error(error);
      }
    );
  }

  markSelectedNodes(nodes: ITreeNode[] | null) {
    if (!nodes) return;

    nodes.forEach((node) => {
      node.checked = this.selectedNodes.some(
        (selected) => selected.ID === node.ID
      );
      node.previous = this.selectedNodes.some(
        (selected) => selected.ID === node.ID
      );
      node.TestingProbabilityTypeCode =
        this.selectedNodes.find((selected) => selected.ID === node.ID)
          ?.TestingProbabilityTypeCode || null;
      if (node.Data) {
        this.markSelectedNodes(node.Data);
      }
    });
  }

// In ContentStudyunitTopicsNodeComponent
private getDefaultTestingProbCode(): string | null {
  if (!this.TestingProbabilityType || !this.TestingProbabilityType.length) return null;

  const avg = this.TestingProbabilityType.find(
    t => (t.Description || '').trim().toLowerCase() === 'average'
  );
  if (avg) return avg.Code;

  const sorted = [...this.TestingProbabilityType].sort(
    (a, b) => a.Display_Order - b.Display_Order
  );
  const mid = sorted[Math.floor((sorted.length - 1) / 2)];
  return mid?.Code ?? null;
}

onCheckboxChange(node?: ITreeNode) {
  if (node && node.checked && (node.TestingProbabilityTypeCode == null || node.TestingProbabilityTypeCode === '')) {
    const defCode = this.getDefaultTestingProbCode();
    if (defCode) node.TestingProbabilityTypeCode = defCode;
  }

  this.selectedNodesChange.emit({
    selectedNodes: this.getCheckedNodes(this.treeNodes),
    checked: !!node
  });
}



  onTestingProbabilityChange(item: any, selectedCode: string) {
    item.TestingProbabilityTypeCode = selectedCode;
    console.log('onTestingProbabilityChange cliked');

    this.selectedNodesChange.emit({selectedNodes:this.getCheckedNodes(this.treeNodes),checked:true});
  }
  onSelectedNodesChange(
   arg :{ selectedNodes: { ID: number; Display_Order: number }[], checked : boolean}
  ) {
    console.log('onSelectedNodesChange cliked');

    this.selectedNodesChange.emit({selectedNodes:arg.selectedNodes,checked:arg.checked||false});
  }
  getCheckedNodes(
    nodes: ITreeNode[] | null
  ): { ID: number; Display_Order: number }[] {
    if (!nodes) return [];

    let selected: { ID: number; Display_Order: number }[] = [];

    nodes.forEach((node) => {
      if (node.checked) {
        selected.push({ ID: node.ID, Display_Order: node.Display_Order });
      }
      if (node.Data) {
        selected = selected.concat(this.getCheckedNodes(node.Data));
      }
    });

    return selected;
  }
  recursivelyExpandNodes(nodes: ITreeNode[] | null) {
    if (!nodes) return;

    nodes.forEach((node) => {
      if (node.ChildNodeExistInd === 'Y' && !node.Data) {
        this.getSubjectTree(node);
      }
      if (node.Data) {
        this.recursivelyExpandNodes(node.Data);
      }
    });
  }
  enableDisableCheckBox(node: ITreeNode): boolean {
    const found = this.AvailableStudyUnits.find(
      (e) => e.Subject_ID === node.ID
    );
    if (found || node.previous) {
      return false;
    } else {
      return true;
    }
  }
}
